<template>
  <v-container grid-list-md fluid text-xs-center style="min-height: 93.4vh;">
    <v-layout row wrap>
      <v-toolbar scroll-target="#scrolling-home">
        <v-toolbar-title>{{ $t('SAHome.title') }}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <div id="scrolling-home" class="scroll-y scrollDesign" style="max-height: 80vh;">
        <v-flex xs12 mt-1>
          <v-layout row wrap>
            <v-flex xs12 sm3 md3 l2 xl2 v-for="item in menu" :key="item.nombre" @click="pushRoute(item.route)" :class="[item.isDummy==true? 'hiddeDummy':'', 'cardSize']">
              <v-hover class="zoomD">
                <v-card slot-scope="{ hover }" :class="`elevation-${hover ? 4 : 0}`">
                  <v-card-title primary-title>
                    <v-flex xs12>
                          <div class="image_container">
                            <img class="custom_fit_height" :src="
                            require(`@/assets/panel/home/${item.iconImage}`)" alt="">
                            </div>
                      <div class="headline">{{ $t(item.name) }}</div>
                      <span>{{ $t(item.description) }}</span>
                    </v-flex>
                  </v-card-title>
                </v-card>
              </v-hover>
            </v-flex>
          </v-layout>
        </v-flex>
      </div>
    </v-layout>
    <GlobalPollsModal />
  </v-container>
</template>

<script>
export default {
  data: () => ({

  }),
  methods: {
    pushRoute(itemRoute) {
      this.$router.push(itemRoute);
      console.log(itemRoute+ "hola");
    },
  },
  computed: {
    menu() {
      return this.$store.getters.getMenuItems;
    }
  }
};
</script>

<style lang="sass" scoope>
@import url("https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.7.0/animate.min.css")
</style>
<style scoped>
/* remove this dummy class once the panel reaches 4 cards or more */
.hiddeDummy{
  opacity: 0;
  pointer-events: none;
}
.cardSize{
  min-width: 220px;
}
.zoomD {
  background-color: rgb(255, 255, 255);
  transition: transform .2s;
  /* Animation */
  margin: 0 auto;
}
.image_container{
  display: flex;
  justify-content: center;
  align-items: center;
}
.custom_fit_height{
  height: 110px;
  width: 110px;
  object-fit: contain;
}

.zoomD:hover {
  transform: scale(1.02);
  /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */
  background-color: rgb(255, 255, 255);
}
</style>

